var React = require('react');

function CrossWhite (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_5439","data-name":"Group 5439","transform":"translate(-1721.793 -90.793)"},[React.createElement("line",{"id":"Line_539","data-name":"Line 539","x1":"43.603","y2":"43.603","transform":"translate(1722.5 91.5)","fill":"none","stroke":"#fff","strokeWidth":"2","key":0}),React.createElement("line",{"id":"Line_540","data-name":"Line 540","x2":"43.603","y2":"43.603","transform":"translate(1722.5 91.5)","fill":"none","stroke":"#fff","strokeWidth":"2","key":1})]));
}

CrossWhite.defaultProps = {"width":"45.017","height":"45.017","viewBox":"0 0 45.017 45.017"};

module.exports = CrossWhite;

CrossWhite.default = CrossWhite;
